import EnDialog from 'Components/base/EnDialog/EnDialog';
import EnButton from 'Components/base/EnButton/EnButton.vue';
import EnSnackbar from 'Components/feedback/EnSnackbar/EnSnackbar.vue';
import EnDataGrid from 'Components/datagrid/EnDataGrid';
import EnPageTitle from 'Components/layout/EnPageTitle/EnPageTitle.vue';
import EnSmallLabeledContent from 'Components/text/EnSmallLabeledContent/EnSmallLabeledContent';
import Breadcrumbs from 'Components/navigation/Breadcrumbs/Breadcrumbs.vue';
import Header from 'Components/datagrid/types/header.ts';
import { useRoute } from 'vue-router';
import { SnackbarType } from 'Components/types/SnackbarType';
export default {
  __name: 'overview',
  setup(__props, _ref) {
    let __expose = _ref.expose;
    __expose();
    const route = useRoute();
    const successMessage = ref();
    const asyncDataGrid = ref();
    const credentialsGenerated = ref(false);
    const accountName = ref(null);
    const accountId = ref(route.query.id);
    const enPowerAccountId = ref(route.query.enPowerId);
    const items = ref([]);
    const generatedModel = ref(null);
    const urls = ref(null);
    const getUrl = computed(() => {
      const parameterObject = {};
      if (accountId.value) {
        parameterObject.id = accountId.value;
      }
      if (enPowerAccountId.value) {
        parameterObject.enPowerId = enPowerAccountId.value;
      }
      const params = new URLSearchParams(parameterObject);
      return "/api/ApiClients/ApiClients?".concat(params.toString());
    });
    const breadcrumbInfo = computed(() => {
      var _urls$value, _urls$value2;
      const route = accountId.value ? {
        href: "".concat((_urls$value = urls.value) === null || _urls$value === void 0 ? void 0 : _urls$value.engineUrl, "/EnFactsAccounts?Name=").concat(accountName.value),
        value: t('ApiClients.url.enFactsAccounts')
      } : {
        href: "".concat((_urls$value2 = urls.value) === null || _urls$value2 === void 0 ? void 0 : _urls$value2.engineUrl, "/EnPowerAccounts"),
        value: t('ApiClients.url.enPowerAccounts')
      };
      return [route, t('ApiClients.title')];
    });
    const headers = computed(() => {
      return [new Header({
        title: t('ApiClients.clientId'),
        value: 'clientId',
        sortable: true,
        minWidth: '200px'
      }), new Header({
        title: t('ApiClients.clientName'),
        value: 'clientName',
        sortable: true,
        minWidth: '200px'
      })];
    });
    async function loadItems() {
      const itemsResponse = await fetch(getUrl.value, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      if (itemsResponse.ok) {
        items.value = await itemsResponse.json();
      }
    }
    function exportItems() {
      asyncDataGrid.value.exportData(items.value);
    }
    async function generateCredentials() {
      credentialsGenerated.value = true;
      const parameterObject = {};
      if (accountId.value) {
        parameterObject.id = accountId.value;
      }
      if (enPowerAccountId.value) {
        parameterObject.enPowerId = enPowerAccountId.value;
      }
      const params = new URLSearchParams(parameterObject);
      const response = await fetch("/api/ApiClients/GenerateClient?".concat(params), {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        successMessage.value.pushMessage(t('common.snackbar.saved'));
        generatedModel.value = await response.json();
        await loadItems();
      }
    }
    provide('reload', {
      loadItems
    });
    onBeforeMount(async () => {
      const requestBody = {
        accountId: accountId.value
      };
      const response = await fetch("/api/Configuration/GetConfigurationForUser", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      if (response.ok) {
        const config = await response.json();
        accountName.value = config.EnFactsAccountName;
        urls.value = {
          engineUrl: config.EngineUrl,
          authUrl: config.AuthUrl
        };
      }
      await loadItems();
    });
    const __returned__ = {
      route,
      successMessage,
      asyncDataGrid,
      credentialsGenerated,
      accountName,
      accountId,
      enPowerAccountId,
      items,
      generatedModel,
      urls,
      getUrl,
      breadcrumbInfo,
      headers,
      loadItems,
      exportItems,
      generateCredentials,
      get EnDialog() {
        return EnDialog;
      },
      EnButton,
      EnSnackbar,
      get EnDataGrid() {
        return EnDataGrid;
      },
      EnPageTitle,
      get EnSmallLabeledContent() {
        return EnSmallLabeledContent;
      },
      Breadcrumbs,
      get Header() {
        return Header;
      },
      get useRoute() {
        return useRoute;
      },
      get SnackbarType() {
        return SnackbarType;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};